import { api } from "../api";

export const transcriptionService = {
  /**
   * Transcribe an audio blob to text using the backend Whisper endpoint.
   *
   * @param audioBlob - Audio data from MediaRecorder (typically audio/webm).
   * @returns The transcribed text, or empty string if nothing was recognised.
   */
  transcribe: async (audioBlob: Blob): Promise<string> => {
    const mimeType = audioBlob.type || "audio/webm";
    // Pick a file extension from the MIME so the backend can identify the format.
    const extMap: Record<string, string> = {
      "audio/webm": "webm",
      "video/webm": "webm",
      "audio/ogg": "ogg",
      "audio/wav": "wav",
      "audio/mpeg": "mp3",
      "audio/mp4": "mp4",
    };
    const ext = extMap[mimeType] || "webm";
    const filename = `recording.${ext}`;

    const result = await api.uploadBlob<{ text: string }>("/transcription/transcribe", audioBlob, filename);
    return result.text || "";
  },
};
